import classnames from 'classnames'

import { RichText, RichTextProps } from '../../molecules'
import Image, { ImageProps } from '../image/Image'
import Link from '../link'

import styles from './topProducts.module.scss'

export interface TopProductItemProps {
  title: string
  id: string
  imageProps: ImageProps
  url?: string
}

export interface TopProductsProps {
  heading: RichTextProps
  productItemProps: TopProductItemProps[]
}

export const TopProducts = (props: TopProductsProps) => {
  return (
    <div className={styles.topProductsWrap}>
      {props.heading && <RichText {...props.heading} className={styles.heading} />}
      <div className={styles.itemsWrap}>
        {props.productItemProps.map((item: TopProductItemProps) => {
          return (
            <Link href={item.url} key={item.id} className={styles.item} withoutBaseStyle>
              <h4 className={styles.itemTitle}>{item.title}</h4>
              <Image alt={item.imageProps.alt} {...item.imageProps} className={classnames(styles.item__image)} />
            </Link>
          )
        })}
      </div>
    </div>
  )
}

export default TopProducts
